import { Directive, OnDestroy, OnInit, TemplateRef, inject, input } from '@angular/core';
import { Observable } from 'rxjs';

import { LayoutService } from '../layout.service';

@Directive({
  selector: '[appCustomTitleTemplate]',
  standalone: true,
})
export class CustomTitleTemplateDirective implements OnInit, OnDestroy {
  readonly #layoutService = inject(LayoutService);

  public readonly templateRef = inject(TemplateRef);

  public appCustomTitleTemplateIncludesSubtitle = input(false);

  public static ngTemplateContextGuard(
    _: CustomTitleTemplateDirective,
    _context: unknown
  ): _context is {
    $implicit: string;
    subtitle$: Observable<string> | null;
    subtitleIsLoading: boolean;
  } {
    return true;
  }

  public ngOnInit(): void {
    this.#layoutService.setCustomTitleTemplate(this.templateRef, this.appCustomTitleTemplateIncludesSubtitle());
  }

  public ngOnDestroy(): void {
    this.#layoutService.clearCustomTitleTemplate(this.templateRef);
  }
}
